<app-drawer-layout
  data-testid="custom-account-drawer"
  [title]="title"
  subtitle="Custom accounts do not sync automatically. Update the balance manually when it changes."
  [state]="layoutState()"
  [errorMessage]="layoutErrorMessage()"
>
  <form
    class="flex flex-1 flex-col"
    data-testid="custom-account-form"
    #customAccountForm="ngForm"
    (ngSubmit)="submitCustomAccount(customAccountForm)"
  >
    <div class="flex flex-col gap-6">
      <app-ui-field class="w-full" label="Account name" [inputId]="'custom-account-name'" [errorLines]="0">
        <input
          id="custom-account-name"
          appUiInput
          data-testid="custom-account-name"
          type="text"
          [(ngModel)]="customAccount().name"
          name="name"
          required
        />
      </app-ui-field>

      <app-ui-field class="w-full" label="Account balance" [inputId]="'custom-account-balance'" [errorLines]="0">
        <app-ui-currency-input
          inputId="custom-account-balance"
          testId="custom-account-balance"
          name="balance"
          required
          [(ngModel)]="customAccount().balance.current"
        />
      </app-ui-field>

      <div>
        <app-ui-checkbox
          inputId="custom-account-include-in-available-balance"
          labelId="custom-account-include-in-available-balance-label"
          ariaDescribedBy="custom-account-include-in-available-balance-description"
          name="includeInAvailableBalance"
          [(ngModel)]="customAccount().includeInAvailableBalance"
        >
          Include this account in Available Balance
        </app-ui-checkbox>
        <p id="custom-account-include-in-available-balance-description" class="mt-1 pl-9 text-body-sm text-text-muted">
          Use this account's balance to calculate how much you can assign to budgets.
        </p>
      </div>
    </div>

    <app-drawer-footer>
      @if (data.accountId) {
        <button appUiButton appearance="outline" tone="danger" type="button" (click)="deleteCustomAccount()">
          Delete account
        </button>
      }
      <span class="flex-1"></span>
      <button
        appUiButton
        tone="primary"
        type="submit"
        data-testid="custom-account-submit"
        [disabled]="!customAccountForm.valid"
      >
        {{ action }}
      </button>
    </app-drawer-footer>
  </form>
</app-drawer-layout>
